import { AppContext } from 'providers/AppContext';
import { useContext, useState } from 'react';
import { SELECTED } from './interestsConsts';

export function useInterests() {
	const ctx = useContext(AppContext);
	const { config, http, state, fetchRelations, goToNextPage, t } = ctx;
	const { API, IS_EMPLOYEE_WEB } = config;
	const { agreementProcessId = '' } = state.context.processInfo || {};
	const [selected, setSelected] = useState(SELECTED);
	const someSelected = Object.keys(selected).some(i => selected[i]);
	const ssn = state.user.kennitala;

	const toggleChecked = (key: string, isChecked: boolean) => {
		setSelected({ ...selected, [key]: isChecked });
	};

	const handleNext = () => {
		if (someSelected && selected.allowStoring) {
			const payload = IS_EMPLOYEE_WEB ? { ...selected, ssn } : selected;
			const msg = t('submit_label', 'interests');
			http.post(`${API.interests}/${agreementProcessId}`, payload, msg).then(() => fetchRelations(true));
		} else {
			goToNextPage();
		}
	};

	return {
		...ctx,
		handleNext,
		selected,
		someSelected,
		toggleChecked
	};
}
